import { createQuery } from "react-query-kit";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import { API_END_POINT } from "../../constants";
import { AxiosError } from "axios";
import PurchaseInvoiceHistoryModel from "../../models/transaction/purchasehistory-model";

const url = getEndPoint(API_END_POINT.ORDER) + "/api/PurchaseInvoice/GetAllPurchaseInvoice";
export const useGetPurchaseList = createQuery<
    PurchaseInvoiceHistoryModel[],
    null,
    AxiosError
>({
    queryKey: ["keyPurchaselist"],
    fetcher: (params) =>
        getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
    // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
    refetchOnWindowFocus: false,
}); 